<h2>Ownership details</h2>
<div class="containers clearfix">
    <ul>
        <li>
            Name
        </li>
        <li>
            {{owner.name}} &nbsp;
        </li>
        <li>
            Date of birth/incorporation
        </li>
        <li>
            {{owner.ownerinformation.birthdate  * 1000 | date:'dd/MM/yyyy'}}&nbsp;
        </li>
        <li>
            Status
        </li>
        <li>
            {{owner.ownertype.OwnershipTypeName}}&nbsp;
        </li>
        <li>
            Ownership amount
        </li>
        <li>
            {{owner.ownershipamount}}&nbsp;
        </li>
        <li>
            Ownership percentage
        </li>
        <li>
            {{owner.ownershippercentage}} %&nbsp;
        </li>
    </ul>


</div>



<h2>Self / Contact person / Legal representative / Authorized person information</h2>
<div class="containers clearfix">
    <div style="width: 100px; border: 1px solid; margin-bottom: 25px;">
        <img [src]=imagePath alt="" style="width: 100px;height: auto;">
    </div>

    <ul>
        <li>
            Name
        </li>
        <li>
            {{owner.ownerinformation.firstname}} &nbsp; {{owner.ownerinformation.middlename}} &nbsp; {{owner.ownerinformation.lastname}}
        </li>
        <li>
            Gender
        </li>
        <li>
            {{GenderText}}
        </li>
        <li>
            Birth Date
        </li>
        <li>
            {{owner.ownerinformation.birthdate * 1000 | date:'dd/MM/yyyy'}}
        </li>
        <li>
            Mobile/Phone number
        </li>
        <li>
            {{owner.ownerinformation.mobilenumber}}
        </li>
        <li>
            Email
        </li>
        <li>
            {{owner.ownerinformation.email}}
        </li>
        <li>
            Occupation
        </li>
        <li>
            {{owner.ownerinformation.occupation}}
        </li>

        <li>
            Religion
        </li>
        <li>
            {{owner.ownerinformation.religion}}
        </li>

        <li>
            Address
        </li>
        <li>

            {{owner.ownerinformation.buildingname}} <br>
            {{owner.ownerinformation.street}} <br>
            {{owner.ownerinformation.locality}} <br>
            {{owner.ownerinformation.city}} <br>
            {{owner.ownerinformation.district}} <br>
            {{owner.ownerinformation.state}} <br>
            {{owner.ownerinformation.country}} <br>
            {{owner.ownerinformation.postalcode}} <br>

        </li>

        <li>
            PAN
        </li>
        <li>
            {{owner.ownerinformation.pan}}&nbsp;
        </li>

        <li>
            Aadhaar
        </li>
        <li>
            {{owner.ownerinformation.aadhar}}&nbsp;
        </li>

        <li>
            Passport
        </li>
        <li>
            {{owner.ownerinformation.passport}}&nbsp;
        </li>

        <li>
            Ration Card
        </li>
        <li>
            {{owner.ownerinformation.rationcard}}&nbsp;
        </li>

        <li>
            DIN
        </li>
        <li>
            {{owner.apdin}}&nbsp;
        </li>

    </ul>
</div>


<h2>Owners additional documents</h2>
<div class="containers clearfix">



    <ul>
        <li>
            PAN
        </li>
        <li>
            {{owner.ownerinformation.pan}}&nbsp;
        </li>
        <li>
            Udhyog Aadhaar
        </li>
        <li>
            {{owner.udhyogaadhaar}}&nbsp;
        </li>
        <li>
            GST Number
        </li>
        <li>
            {{owner.gstnumber}}&nbsp;
        </li>
        <li>
            CIN
        </li>
        <li>
            {{owner.cin}}&nbsp;
        </li>
        <li>
            Partnership Deed
        </li>
        <li>
            {{owner.partnershipdeed}}&nbsp;
        </li>
        <li>
            Government Approval Letter
        </li>
        <li>
            {{owner.approvalletter}}&nbsp;
        </li>

        <li>
            Certificate of Incorporation
        </li>
        <li>
            {{owner.incorporationcertificate}}&nbsp;
        </li>

        <li>
            SEBI Approval Certificate
        </li>
        <li>
            {{owner.approvalletter}}&nbsp;
        </li>

        <li>
            NGO/Trust registration number
        </li>
        <li>
            &nbsp;
        </li>

        <li>
            NGO/Trust approval letter
        </li>
        <li>
            &nbsp;
        </li>

        <li>
            Legal Will
        </li>
        <li>
            {{owner.legalwill}}&nbsp;
        </li>

        <li>
            Power of attorney
        </li>
        <li>
            {{owner.poa}}&nbsp;
        </li>

        <li>
            Guardian agreement
        </li>
        <li>
            {{owner.guardianagreement}}&nbsp;
        </li>

        <li>
            Legal Contract
        </li>
        <li>
            {{owner.legalcontract}}&nbsp;
        </li>


        <li>
            Death Certificate
        </li>
        <li>
            {{owner.deathcertificate}}&nbsp;
        </li>

        <li>
            Certificate of Original/First/Giver
        </li>
        <li>
            &nbsp;
        </li>

    </ul>
</div>

<div>
<input type="button" class="appButton center" style="display: block; width: 500px;" value="View / Share Owner's documents" (click)="onOwnersDocuments(owner)">
</div>